import React from "react";
import { ContentSection, createListTableColumns, depascalize, ensure, ListTable, renderNames } from "sprint-common-web";

import { EncodeSpecificationContentType } from "../../../../../common/types/EncodeSpecificationContentType";
import { SystemPlatformDetailsSpecificationItem } from "../../SystemPlatformDetailsItem";
import { EditSpecificationButton } from "../edit/EditSpecificationButton";
import { useSpecificationListing } from "./useSpecificationListing";

export const SpecificationListing: React.FC = () => {
    const { items, isLoading } = useSpecificationListing();

    const columns = createListTableColumns<SystemPlatformDetailsSpecificationItem>([
        {
            type: "basic",
            key: "encodeSpecificationContentType",
            name: "Encode specification content type",
            minWidth: 250,
            maxWidth: 250,
            isSortable: true,
            onRender: renderType
        },
        {
            type: "basic",
            key: "defaultEncodeSpecificationName",
            name: "Default specification",
            minWidth: 170,
            maxWidth: 200
        },
        {
            type: "basic",
            key: "encodeSpecifications",
            name: "Additional specifications",
            minWidth: 170,
            maxWidth: 200,
            onRender: renderNames
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 64,
            buttons: [
                {
                    id: "edit",
                    getItemId: (item) => item.encodeSpecificationContentType.toString(),
                    render: EditSpecificationButton
                }
            ]
        }
    ]);

    return (
        <ContentSection header="Encode">
            <ListTable columns={columns} items={items} isLoading={isLoading} />
        </ContentSection>
    );
};

const renderType = (item: SystemPlatformDetailsSpecificationItem) => {
    ensure(item.encodeSpecificationContentType, "Item is missing encode specification content type");

    return <>{depascalize(EncodeSpecificationContentType[item.encodeSpecificationContentType])}</>;
};
